// @ts-nocheck
/* eslint-disable camelcase */
import { GetInitialStateInner } from 'Jsx/Utils/getBaseInitialState';

import { AppProps } from './App';
import { RawPageData } from './types';

const getInitialState: GetInitialStateInner<AppProps, RawPageData> = (
  crehanaAppData,
  _,
  fullInitialState,
) => {
  return {
    catalogUrl: fullInitialState.keys_crehana_urls.courses_all,
    accumulativeDiscount: crehanaAppData.cumulative_discount,
  };
};

export default getInitialState;
